/* eslint-disable */

import React, { useCallback, useMemo, useState } from 'react';
import * as cs from '../components/common/common-styles';
// import { BlackButton, WhiteButton } from 'common/navigation-buttons';
import { Checkbox } from 'semantic-ui-react';
import * as rr from './revenue-styles';
import styled, { css } from 'styled-components';
import { Button } from 'semantic-ui-react';


const navigationButtonBase = css`
  height: 36px;
  border-radius: 5px;
  text-transform: none;
`;

const textBase = css`
  font-family: 'Lato';
  font-size: 14px;
  letter-spacing: normal;
`;

const WhiteButton = styled(Button)`
  &&& {
    ${navigationButtonBase}
    width: ${(props) => props.width || '100px'};
    border: solid 1px #dfe3e9;

    .MuiButton-label {
      ${textBase}
      color: #5c5d5d;
    }
  }
`;

const BlackButton = styled(Button)`
  &&& {
    ${navigationButtonBase}
    width: ${(props) => props.width || '200px'};
    background-color: ${(props) => props.disabled ? 'rgb(153,154,154)' : '#1b1c1d'};

    .MuiButton-label {
      ${textBase}
      font-weight: bold;
      color: #ffffff;
    }
  }
`;

export function RevenueModal(props) {
  const {
    open,
    handleClose,
    taxablePeriods,
    updateTaxablePeriods,
    modalOpen,
    setModalOpen,
  } = props;

  const availableYears = Object.keys(taxablePeriods).sort().reverse();

  const [activeYearIndex, setActiveYearIndex] = useState(0);

  const activeYear = availableYears[activeYearIndex];

  return (
    <cs.DarkModal open={modalOpen} onClose={() => setModalOpen(false)}>
      <rr.ReportingWindow>
        <rr.ReportingHeaderSection>
          <rr.ReportingHeaderText>Report Additional TOT</rr.ReportingHeaderText>
        </rr.ReportingHeaderSection>

        <rr.ReportingBody>
          <cs.BoldedLabel bold style={{ marginBottom: '14px' }}>
            Select the periods you want to report TOT, including reporting $0.00 receipts for that period.
          </cs.BoldedLabel>

          <rr.StyledTabs value={activeYearIndex} onChange={(e, v) => setActiveYearIndex(v)} indicatorColor="primary">
            {availableYears.map((year) => <rr.StyledTab key={year} label={year} />)}
          </rr.StyledTabs>

          <rr.MonthLayout>
            {taxablePeriods[activeYear]?.map((period, i) => {
              return (
                <Checkbox
                  key={`${activeYear}-${period.label}`}
                  label={period.label}
                  name={`${activeYear}[${i}].checked`}
                  checked={taxablePeriods[activeYear][i].checked}
                  onChange={(event, { name, checked }) => { updateTaxablePeriods(name, checked); }}
                  disabled={taxablePeriods[activeYear][i].disabled}
                />
              )
            })}
          </rr.MonthLayout>
        </rr.ReportingBody>

        <rr.ReportingFooterSection>
          <WhiteButton onClick={() => setModalOpen(false)} width="75px">
            Close
          </WhiteButton>
          {/* <BlackButton onClick={handleContinue} width="120px">
            Continue
          </BlackButton> */}
        </rr.ReportingFooterSection>
      </rr.ReportingWindow>
    </cs.DarkModal>
  );
}
